// import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ReporteDocente from "./ReporteDocente";
import Fallback from "./Fallback";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Sin hash: mensaje para acceder con el enlace del correo (producción) */}
        <Route path="/" element={<Fallback />} />
        {/* Con hash: reporte filtrado por institución */}
        <Route path="/:hash" element={<ReporteDocente />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;